<template>
  <div class="c-serviceSearchHeaderFacetCassettesWrapper">
    <div
      class="c-serviceSearchHeaderFacetCassettes"
      ref="draggableContainer"
      @mousedown="onMouseDownArea"
      @mousemove="onMouseMoveArea"
      @mouseup="isScrolling = false; isMouseDown = false"
      @mouseleave="isScrolling = false; isMouseDown = false"
    >
      <div class="c-serviceSearchHeaderFacetCassettes_inner">
        <ServiceSearchHeaderFacetCassette
          ref="attachmentCassettes"
          v-for="(cassette, index) in cassettes.master.valuesList"
          :key="`cassette${cassette.id}_${index}`"
          :cassette="cassette"
          :option="cassettes.option"
          :allows-multiple-select="allowsMultipleSelect"
          :is-search-icon="cassettes.master.isSearchIcon"
          :icon-image="cassetteIconUrl(cassettes.master.key, cassette)"
          :is-scrolling="isScrolling"
          v-intersect-on.each="{ root: $refs.draggableContainer, threshold: 1 }"
          class="c-serviceSearchHeaderFacetCassettes_cassette"
          @input="changeCassette($event)"
          @intersect.native="onAttachedCassetteIntersect($event, index)"
        >
          <span class="c-facetLabel">{{ cassette.name }}</span>
        </ServiceSearchHeaderFacetCassette>
      </div>
    </div>
    <transition name="cassette-scroll-button">
      <div
        v-if="showLeftCassettesScrollButton"
        class="c-serviceSearchHeaderFacetCassettes_cassettesLeftArrow"
        @click="scrollLeftCassettes"
      >
        <CoconalaIcon name="chevron-left" />
      </div>
    </transition>
    <transition name="cassette-scroll-button">
      <div
        v-if="showRightCassettesScrollButton"
        class="c-serviceSearchHeaderFacetCassettes_cassettesRightArrow"
        @click="scrollRightCassettes"
      >
        <CoconalaIcon name="chevron-right" />
      </div>
    </transition>
  </div>
</template>
<script>
import ServiceSearchHeaderFacetCassette from './ServiceSearchHeaderFacetCassette'

export default {
  name: 'ServiceSearchHeaderFacetCassettes',
  components: {
    ServiceSearchHeaderFacetCassette
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    cassettes: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isMouseDown: false,
      isScrolling: false,
      lastMousePositionX: 0,
      /** 添付ファイルリスト左スクロールボタン表示フラグ */
      showLeftCassettesScrollButton: false,
      /** 添付ファイルリスト右スクロールボタン表示フラグ */
      showRightCassettesScrollButton: false,
      visibleCassettesIndex: []
    }
  },
  computed: {
    allowsMultipleSelect() {
      return this.cassettes.master.type === 'checkbox'
    }
  },
  methods: {
    cassetteIconUrl(key, cassette) {
      const iconType = (() => {
        switch (key) {
          case 'master_category_type_id':
            return 'category_type_id'
          // TODO: category_v2 不要になるコンポーネントのはずなので確認後に問題なければコンポーネントごと削除
          case 'provider_levels':
            return 'provider_levels'
          default:
            return 'facet_id'
        }
      })()
      const iconId = (() => {
        switch (key) {
          case 'master_category_type_id':
          case 'provider_levels':
            return cassette.value
          default:
            return cassette.id
        }
      })()

      return this.$coconala.fileURL(
        `/staticfiles/images/categories/facet/${iconType}_${iconId}.jpg`
      )
    },
    changeCassette(value) {
      this.$emit('change-cassette', {
        key: this.cassettes.master.key,
        value: value,
        categoryId: this.cassettes.option.relatedCategoryId
      })
    },
    /**
     * マウスによるスクロールを可能にするための処理
     * mousedown時にそのマウスの位置を保持＆スクロール状態を有効化
     * @param {MouseEvent} e
     */
    onMouseDownArea(e) {
      this.isMouseDown = true
      this.lastMousePositionX = e.x
    },
    /**
     * マウスによるスクロールを可能にするための処理
     * mousemove時にマウスを動かした分だけスクロールさせる
     * @param {MouseEvent} e
     */
    onMouseMoveArea(e) {
      if (!this.isMouseDown) {
        return
      }
      this.isScrolling = true
      if (this.$refs.draggableContainer) {
        const { scrollLeft } = this.$refs.draggableContainer
        const scrollDelta = e.x - this.lastMousePositionX
        this.lastMousePositionX = e.x
        this.$refs.draggableContainer.scrollTo(scrollLeft - scrollDelta, 0)
      }
    },
    /**
     * ファセットのIntersectionObserverハンドラ
     * 最初と最後の添付ファイルのスクロール領域内への出入りを検知して左右のボタンを表示制御する
     * @param {IntersectionObserverEntry} e
     * @param {number} index
     */
    onAttachedCassetteIntersect(e, index) {
      if (index === 0) {
        this.showLeftCassettesScrollButton = !e.isIntersecting
      }
      if (index === this.cassettes.master.valuesList.length - 1) {
        this.showRightCassettesScrollButton = !e.isIntersecting
      }
      if (e.isIntersecting) {
        this.visibleCassettesIndex.push(index)
      } else {
        const deleteIndex = this.visibleCassettesIndex.indexOf(index)
        if (deleteIndex >= 0) {
          this.visibleCassettesIndex.splice(deleteIndex, 1)
        }
      }
    },
    getAttachmentCassettes() {
      let attachmentCassettes = this.$refs.attachmentCassettes
      if (!attachmentCassettes) return null
      // 配列で取得できる想定だが配列じゃなかった場合の考慮
      if (!Array.isArray(attachmentCassettes)) {
        attachmentCassettes = [attachmentCassettes]
      }
      return attachmentCassettes
    },
    /** ファセット一覧を次の要素が完全に見える位置まで左へスクロール */
    scrollLeftCassettes() {
      /** @type {Element} */
      const draggableContainer = this.$refs.draggableContainer
      /** @type {VueComponent[]} */
      const attachmentCassettes = this.getAttachmentCassettes()
      if (!draggableContainer || !attachmentCassettes) return
      const { left } = draggableContainer.getBoundingClientRect()
      const overflowLeftPositions = attachmentCassettes
        .map(v => v.$el.getBoundingClientRect().left)
        .filter(vLeft => vLeft < left)
        .sort((a, b) => a - b)
        .slice(-this.visibleCassettesIndex.length)
      if (overflowLeftPositions.length > 0) {
        const overflowLeftMax = Math.min(...overflowLeftPositions)
        draggableContainer.scrollTo({
          left: draggableContainer.scrollLeft - (left - overflowLeftMax),
          behavior: 'smooth'
        })
      }
    },
    /** ファセット一覧を次の要素が完全に見える位置まで右へスクロール */
    scrollRightCassettes() {
      /** @type {Element} */
      const draggableContainer = this.$refs.draggableContainer
      /** @type {VueComponent[]} */
      const attachmentCassettes = this.getAttachmentCassettes()
      if (!draggableContainer || !attachmentCassettes) return
      const { right } = draggableContainer.getBoundingClientRect()
      const overflowRightPositions = attachmentCassettes
        .map(v => v.$el.getBoundingClientRect().right)
        .filter(vRight => vRight > right)
        .sort((a, b) => a - b)
        .slice(0, this.visibleCassettesIndex.length)
      if (overflowRightPositions.length > 0) {
        const overflowRightMin = Math.max(...overflowRightPositions)
        draggableContainer.scrollTo({
          left: draggableContainer.scrollLeft + (overflowRightMin - right),
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-serviceSearchHeaderFacetCassettesWrapper {
  position: relative;
}

.c-serviceSearchHeaderFacetCassettes {
  height: 98px;
  overflow-x: scroll;
  white-space: nowrap;

  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  &_inner {
    display: flex;

    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  &_cassette {
    & + & {
      margin-left: 16px;
    }
  }

  &_cassettesLeftArrow,
  &_cassettesRightArrow {
    position: absolute;
    // 縦中央 + 上部paddingの半分
    top: 50%;
    display: flex;
    width: 32px;
    height: 32px;
    border: 1px solid $ds2-color-gray-25;
    border-radius: 50%;
    background-color: $color-white;
    box-shadow: 0 4px 8px rgba(2, 16, 66, 0.1);
    color: $ds2-color-gray-600;
    cursor: pointer;
    transform: translateY(-50%);

    align-items: center;
    justify-content: center;
  }

  &_cassettesLeftArrow {
    left: 16px;
    padding-top: 2px;
    padding-right: 2px;
  }

  &_cassettesRightArrow {
    right: 16px;
    padding-top: 2px;
    padding-left: 2px;
  }
}

.c-facetLabel {
  display: -webkit-box;
  overflow: hidden;
  color: $color-gray-900;
  text-align: left;
  letter-spacing: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 1.2;

  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}

.cassette-scroll-button-enter-active,
.cassette-scroll-button-leave-active {
  transition: opacity 0.2s ease-out;
}
.cassette-scroll-button-enter,
.cassette-scroll-button-leave-to {
  opacity: 0;
}

@media (max-width: breakpoint(Search, M)) {
  .c-serviceSearchHeaderFacetCassettes {
    padding-left: 12px;
    &_inner {
      &::after {
        display: block;
        padding-right: 12px;
        content: '';
      }
    }
    &_cassette {
      & + & {
        margin-left: 8px;
      }
    }
    &_cassettesLeftArrow,
    &_cassettesRightArrow {
      display: none;
    }
  }
}
</style>
